/* Fashion CITY — 커스텀 베이스볼 캡 스타일/색상 사진
   맨 위에서 스타일을 고르면 그 스타일의 색이 쫙 나오고,
   색을 누르면 옆의 큰 사진이 그 모자로 바뀝니다.

   ★ 색을 넣거나 빼려면 아래 목록만 고치면 됩니다.  ['보이는 이름', '사진 주소']
   ★ 사진은 홀세일 상품에 이미 올라가 있는 이미지를 그대로 가리킵니다.
     - 1201        : "Pigment Dyed Cotton Baseball Dad Cap"        (sku 12-1201)
     - 1301        : "Plain Solid Stone Washed Adjustable Dad Cap" (sku 12-M1301-NEW)
     - 1155/1156   : "Plain Denim Cotton Baseball Cap Dad Hat"     (sku 12-1155-1156)

   ※ 트러커 모자는 이 파일이 아니라 assets/fc-po-colors.js 에 따로 들어 있습니다.
   ※ 이 파일은 fc-po-colors.js 다음에 실행됩니다.
*/
window.FCPO_STYLES = window.FCPO_STYLES || {};
window.FCPO_PLACE_BY_HANDLE = window.FCPO_PLACE_BY_HANDLE || {};
(function () {
  var HANDLE = 'custom-baseball-cap-your-design';
  var P = 'https://cdn.shopify.com/s/files/1/0372/5544/6665/products/';
  var F = 'https://cdn.shopify.com/s/files/1/0372/5544/6665/files/';

  /* 1201 — 피그먼트 다이드 (19색) */
  function pig(name, file) { return [name, P + 'NH-1201-' + file + '-01.jpg']; }
  var C1201 = [
    pig('Black', 'BLACK'),
    pig('Charcoal', 'CHARCOAL'),
    pig('Grey', 'GREY'),
    pig('Sand', 'SAND'),
    pig('Khaki', 'KHAKI'),
    pig('Dark Brown', 'DARK-BROWN'),
    ['Rust', F + '12-1201-RUST.jpg'],
    pig('Burgundy', 'BURGUNDY'),
    pig('Red', 'RED'),
    pig('Coral', 'CORAL'),
    pig('Yellow', 'Yellow'),
    pig('Light Pink', 'LIGHT-PINK'),
    pig('Purple', 'PURPLE'),
    pig('Royal', 'ROYAL'),
    pig('Blue', 'BLUE'),
    pig('Aqua', 'AQUA'),
    pig('Turquoise', 'TURQUOISE'),
    pig('Green', 'GREEN'),
    pig('Olive', 'OLIVE')
  ];

  /* 1301 — 스톤 워시드 (20색) */
  function stw(name, file) { return [name, F + '12-M1301-' + file + '.jpg']; }
  var C1301 = [
    stw('Black', 'BLACK'),
    stw('Charcoal', 'CHARCOAL'),
    stw('Grey', 'GREY'),
    stw('White', 'WHITE'),
    stw('Putty', 'PUTTY'),
    stw('Khaki', 'KHAKI'),
    stw('Copper', 'COPPER'),
    stw('Burgundy', 'BURGUNDY'),
    stw('Red', 'RED'),
    stw('Orange', 'ORANGE'),
    stw('Gold', 'GOLD'),
    stw('Yellow', 'YELLOW'),
    stw('Light Pink', 'LIGHTPINK'),
    stw('Navy', 'NAVY'),
    stw('Royal Blue', 'ROYALBLUE'),
    stw('Sky Blue', 'SKYBLUE'),
    stw('Aqua', 'AQUA'),
    stw('Turquoise', 'TURQUOISE'),
    stw('Dark Green', 'DARKGREEN'),
    stw('Olive', 'OLIVE')
  ];

  /* 1155 / 1156 — 데님 (3색) */
  function den(name, file) { return [name, P + 'NH-1155-1156-' + file + '01.jpg']; }
  var CDEN = [
    den('Black Denim', 'BLACK'),
    den('Dark Blue', 'DARKBLUE'),
    den('Light Blue', 'LIGHTBLUE')
  ];

  /* 자수 자리 — 스타일마다 사진 프레임이 달라서 따로 잡습니다.
     x, y : 사진 왼쪽 위가 0,0 / 오른쪽 아래가 100,100  (y 가 클수록 아래)
     w    : Medium 일 때 폭 (사진 가로폭의 %)
     ※ 베이스볼 캡은 앞판이 트러커만큼 크지 않아서 글자를 세로로 늘리지 않습니다.
        (늘리려면 h 를 넣으세요. 예: h: 8 — 트러커는 fc-po-colors.js 에서 h 를 씁니다.)
     ※ 데님은 사진이 훨씬 크게 잘려 있어서 숫자가 다릅니다.
  */
  var PL1201 = { v: 'Front panel', x: 50, y: 40, w: 32, sizes: [2, 3, 4] };
  var PL1301 = { v: 'Front panel', x: 50, y: 42, w: 32, sizes: [2, 3, 4] };
  var PLDEN  = { v: 'Front panel', x: 50, y: 36, w: 44, sizes: [2, 3, 4] };

  window.FCPO_STYLES[HANDLE] = {
    styleLabel: 'Cap style',
    colorLabel: 'Cap color',
    styles: [
      { n: 'Pigment Dyed', sku: '1201',      colors: C1201, place: PL1201 },
      { n: 'Stone Washed', sku: '1301',      colors: C1301, place: PL1301 },
      { n: 'Denim',        sku: '1155/1156', colors: CDEN,  place: PLDEN }
    ]
  };

  /* 앞판 자수만 받습니다 (옆면·뒷면 사진이 색깔별로 없어서) */
  window.FCPO_PLACE_BY_HANDLE[HANDLE] = [PL1201];
})();